<script lang="ts">
import PaginationNew from "@/Components/PaginationNew.vue";
import ScrollUtilities from "@/Helpers/ScrollUtilities";
import AppLayout from "@/Layouts/App.vue";
import CompaniesList from "@/Pages/CompaniesList.vue";
import SearchCompany from "@/Pages/SearchCompany.vue";
import { EconomicSectors, QualificationInput, QualificationsGroups } from "@/Types";
import { CompanyId } from "@/Types/company";
import { CompanySearchResults } from "@/Types/pagination";
import axios from "axios";
import { defineComponent, PropType } from "vue";

type MainSearchVueData = {
    companies: CompanySearchResults;
    qualificationInput: QualificationInput;
    preselected: QualificationInput;

    searchingProcess: boolean;
    noCompanies: boolean;

    detailViewCompanyId: CompanyId | null;
    searchStr: string;
};

export default defineComponent({
    name: "MainSearchVue",
    components: {
        SearchCompany,
        CompaniesList,
        PaginationNew,
    },
    layout: AppLayout,
    props: {
        qualificationGroups: {
            type: Array as PropType<QualificationsGroups>,
            required: true,
        },
        economicSectors: {
            type: Array as PropType<EconomicSectors>,
            required: true,
        },
    },
    data: (): MainSearchVueData => {
        return {
            companies: { data: false },
            qualificationInput: [],
            preselected: [],

            searchingProcess: false,
            noCompanies: false,

            detailViewCompanyId: null,
            searchStr: "",
        };
    },
    mounted() {
        const localQualificationInput = localStorage.getItem("qualificationInput");

        if (localQualificationInput) {
            this.preselected = JSON.parse(localQualificationInput);
            this.qualificationInput.slice(0);
            this.preselected.forEach((item) => {
                this.qualificationInput.push({ id: item.id, value: item.value });
            });
        }
    },
    methods: {
        scrollToTop(): void {
            ScrollUtilities.jumpToTop();
        },
        search(page = 1, pagination = false) {
            if (this.searchingProcess || this.searchStr.length < 3) return;
            if (pagination) this.scrollToTop();
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let vueThis = this;
            this.searchingProcess = true;
            var d = new Date();
            var startSearching = d.getTime();
            axios
                .post("/search", { search: this.searchStr, page: page })
                .then(function (result) {
                    var d = new Date();
                    var endSearching = d.getTime();
                    var timeDiff = endSearching - startSearching;
                    var minWaitingTime = Math.max(0, 3000 - timeDiff);
                    if (pagination) minWaitingTime = 500;
                    setTimeout(function () {
                        vueThis.noCompanies = result.data.companies.total === 0;
                        vueThis.companies = result.data.companies;
                        vueThis.searchingProcess = false;
                        vueThis.$nextTick(function () {
                            // $("#companyList").get(0).scrollIntoView();
                            vueThis.scrollToTop();
                        });
                    }, minWaitingTime);

                    /*
                        vueThis.companies.splice(0);
                        const arrayForSorting = [];
                        for(const [key, company] of Object.entries(result.data.companies))
                        { 
                            arrayForSorting.push({'index': key, 'rating': company.rating});
                        };
                        arrayForSorting.sort(function(a, b) {
                            if (a.rating > b.rating) return -1;
                            if (a.rating < b.rating) return 1;
                            return 0;
                        });
                        arrayForSorting.forEach((item) =>
                        {
                            vueThis.companies.push(result.data.companies[item.index]); 
                        });
                        */
                })
                .catch((error) => {
                    this.searchingProcess = false;
                    console.error(error);
                });
        },

        resetSearch(): void {
            this.changeDetailViewCompanyId(null);
            this.companies.data = false;
            this.$nextTick(() => {
                this.scrollToTop();
            });
        },
        changeDetailViewCompanyId(companyId: CompanyId | null): void {
            this.detailViewCompanyId = companyId;
        },
    },
});
</script>

<template>
    <div class="main-wrapper flex flex--v flex--valign-c flex--gap-60">
        <template v-if="companies.data === false">
            <SearchCompany ref="startOfJobfuchs" :searching-process="searchingProcess" :economic-sectors="economicSectors" :search-string="searchStr" @change-input-value="(val) => (searchStr = val)" @click-search-company="search()" />
        </template>

        <CompaniesList
            v-else
            :qualification-input="qualificationInput"
            :qualification-groups="qualificationGroups"
            :companies="companies.data"
            :no-companies="noCompanies"
            :detail-view-company-id="detailViewCompanyId"
            @click-back-to-search="resetSearch"
            @change-detail-view-company-id="changeDetailViewCompanyId" />

        <PaginationNew v-if="companies.data !== false && companies.last_page > 1 && !detailViewCompanyId" :pagination-data="companies" class="pagination-new" @paginate="search($event, true)" />
    </div>
</template>

<style lang="scss" scoped></style>
